// extracted by mini-css-extract-plugin
export default {"container":"devices_container__XIWUJ","section":"devices_section__MAyQW"};